import { useContext, useMemo } from 'react';
import { getAnalyticFormat } from 'shared/lib/authUtils';
import { PermissionContext } from './PermissionProvider';

/**
 * useAnalyticFormat — reactive analytics dashboard format for the Permission
 * Access Layer (SA-1849).
 *
 * Reads `company` from the reactive PermissionContext projection and derives the
 * format from `analytic_setting`, which rides inside the same `company` blob that
 * `applyPermissionsFromMe` rewrites on login and on token refresh — so no new
 * watched storage key was needed. Mirrors `useTamperDetectionAccess`.
 *
 * The returned flag is named for what the UI renders, not for the backend enum
 * value, so the `ZAI_DASHBOARD` codename stays out of component logic.
 *
 * @returns {{ analyticType: string, isSimplifiedAnalytics: boolean }}
 */
export const useAnalyticFormat = () => {
  const { company } = useContext(PermissionContext);

  return useMemo(() => getAnalyticFormat(company?.analytic_setting), [company]);
};
